import { render, staticRenderFns } from "./LessonHasBeenCanceledNotification.vue?vue&type=template&id=61c8bee1&"
import script from "./LessonHasBeenCanceledNotification.vue?vue&type=script&lang=js&"
export * from "./LessonHasBeenCanceledNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports